import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-wrap items-center space-x-1 text-gray-500"
}

import { computed } from 'vue';
import { IsActiveFlag, CreatedAudit, UpdatedAudit } from '@/types';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiAuditStatusInfo',
  props: {
    modelValue: {}
  },
  setup(__props: any) {



const hasIsActive = computed(() => typeof __props.modelValue?.isActive === 'boolean');

return (_ctx: any,_cache: any) => {
  const _component_UiIsActiveBadge = _resolveComponent("UiIsActiveBadge")!
  const _component_UiAuditInfo = _resolveComponent("UiAuditInfo")!

  return (_ctx.modelValue)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["space-y-2 text-sm md:flex", [hasIsActive.value ? 'md:justify-between' : 'md:justify-end']])
      }, [
        (hasIsActive.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("span", null, _toDisplayString(_ctx.$t('core.status')) + ": ", 1),
              _createVNode(_component_UiIsActiveBadge, { "model-value": _ctx.modelValue }, null, 8, ["model-value"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_UiAuditInfo, { "model-value": _ctx.modelValue }, null, 8, ["model-value"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})